// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3uZle","productName":"Table_productName__2AOia"};